import { pick, reduce, max, pathOr, map, compose, clamp } from 'ramda';
import {
    TEETIMES_RESPONSE,
    CALANDER_UPDATE,
    TIMERANGE_UPDATE,
    PRICERANGE_UPDATE,
    GOLFCART_UPDATE,
    HOLECOUNT_UPDATE,
    GOLFERCOUNT_UPDATE,
    RESET_FILTERS,
    TAKE_FILTER_SNAPSHOT,
    RELEASE_FILTER_SNAPSHOT
} from '../actions';
import filterTeeTimes from '../lib/filter-teetimes';

const extractFilters = pick(['timeRange', 'priceRange', 'holeCountSelection', 'golfCartSelection', 'golferCount']);
// use this to dynamically set the price range for the price slider
const getMaxPrice = compose(
    clamp(50, Infinity),
    reduce(max, 0),
    map(Math.ceil),
    map(pathOr(150, ['greensFees', 'Value']))
);

const defaultState = {
    teetimes: [],
    matchingTeeTimes: [],
    selectedDate: new Date(),
    timeRange: {
        min: 5,
        minSelected: 5,
        minSelectedFormatted: '5 AM',
        max: 21,
        maxSelected: 21,
        maxSelectedFormatted: '9 PM'
    },
    priceRange: {
        min: 0,
        minSelected: 0,
        max: 250,
        maxSelected: 250,
        minTextInput: '0',
        maxTextInput: '250'
    },
    holeCountSelection: '0',
    golfCartSelection: '0',
    golferCount: 0,
    snapshot: undefined
}

function filters(state = defaultState, action) {
    switch (action.type) {
        case TEETIMES_RESPONSE: {
            const teetimes = action.payload;
            const maxPrice = getMaxPrice(teetimes);
            const newState = { ...state, priceRange: { ...state.priceRange, max: maxPrice, maxSelected: maxPrice, maxTextInput: maxPrice.toString() } }
            const filters = extractFilters(newState);
            const matchingTeeTimes = filterTeeTimes(filters, teetimes);
            return  {...newState, teetimes, matchingTeeTimes }
        }
        /*
            the application caches teetimes
            for the current day and performs filtering based on that day so when a calander update occurs we need just update the store
            and listen for this action in a redux saga and make the call async for the updated teetimes and dispatch the TEETIME_RESPONSE action
            with the response which will be taken care of in this reducer
        */
        case CALANDER_UPDATE:
            return { ...state, selectedDate: action.payload }
        case TIMERANGE_UPDATE: {
            const timeRange = { ...state.timeRange, ...action.payload }
            const filters = { ...extractFilters(state), timeRange }
            const matchingTeeTimes = filterTeeTimes(filters, state.teetimes);
            return {...state, timeRange, matchingTeeTimes }
        }
        case PRICERANGE_UPDATE: {
            const priceRange = { ...state.priceRange, ...action.payload }
            const filters = { ...extractFilters(state), priceRange }
            const matchingTeeTimes = filterTeeTimes(filters, state.teetimes);
            return  { ...state, priceRange, matchingTeeTimes }
        }
        case GOLFCART_UPDATE: {
            const golfCartSelection = action.payload;
            const filters = { ...extractFilters(state), golfCartSelection }
            const matchingTeeTimes = filterTeeTimes(filters, state.teetimes);
            return {...state, golfCartSelection, matchingTeeTimes }
        }
        case HOLECOUNT_UPDATE: {
            const holeCountSelection = action.payload;
            const filters = { ...extractFilters(state), holeCountSelection }
            const matchingTeeTimes = filterTeeTimes(filters, state.teetimes);
            return { ...state, holeCountSelection, matchingTeeTimes }
        }
        case GOLFERCOUNT_UPDATE: {
            const golferCount = action.payload;
            const filters = { ...extractFilters(state), golferCount }
            const matchingTeeTimes = filterTeeTimes(filters, state.teetimes);
            return { ...state, golferCount, matchingTeeTimes }
        }
        case RESET_FILTERS: {
            const filters = extractFilters(defaultState)
            const matchingTeeTimes = filterTeeTimes(filters, state.teetimes);
            return { ...state, ...filters, matchingTeeTimes, snapshot: undefined }
        }
        // DEAD CODE
        case TAKE_FILTER_SNAPSHOT: {
            const snapshot = extractFilters(state)
            return { ...state, snapshot }
        }
         // DEAD CODE
        case RELEASE_FILTER_SNAPSHOT:
            return { ...state, snapshot: undefined }
        default:
            return state
    }
}

export default filters;


// WEBPACK FOOTER //
// ./src/reducers/filters.js